// Sovereign Domain Category Accent Glow Engine
// Deterministically classifies domains into category color accents

const CATEGORIES = {
  ai: {
    name: 'AI & Intelligence',
    color: '#a855f7', // Purple
    glow: 'rgba(168, 85, 247, 0.25)',
    border: 'rgba(168, 85, 247, 0.4)',
    keywords: ['openai', 'anthropic', 'huggingface', 'midjourney', 'perplexity', 'cursor', 'groq', 'mistral', 'cohere', 'replicate', 'claude', 'chatgpt'],
  },
  dev: {
    name: 'Developer & Cloud',
    color: '#10b981', // Emerald
    glow: 'rgba(16, 185, 129, 0.25)',
    border: 'rgba(16, 185, 129, 0.4)',
    keywords: ['github', 'vercel', 'cloudflare', 'vite', 'tailwind', 'docker', 'npm', 'aws', 'netlify', 'gitlab', 'stackoverflow', 'react', 'nextjs', 'node'],
  },
  design: {
    name: 'Design & Visuals',
    color: '#f43f5e', // Rose
    glow: 'rgba(244, 63, 94, 0.25)',
    border: 'rgba(244, 63, 94, 0.4)',
    keywords: ['figma', 'dribbble', 'behance', 'unsplash', 'coolors', 'awwwards', 'pinterest', 'font', 'icon', 'artstation'],
  },
  finance: {
    name: 'Finance & Web3',
    color: '#f59e0b', // Amber
    glow: 'rgba(245, 158, 11, 0.25)',
    border: 'rgba(245, 158, 11, 0.4)',
    keywords: ['binance', 'coingecko', 'stripe', 'coinbase', 'uniswap', 'tradingview', 'kraken', 'ethereum', 'bitcoin', 'solana', 'paypal'],
  },
  media: {
    name: 'Media & Social',
    color: '#06b6d4', // Cyan
    glow: 'rgba(6, 182, 212, 0.25)',
    border: 'rgba(6, 182, 212, 0.4)',
    keywords: ['youtube', 'twitter', 'x.com', 'reddit', 'twitch', 'spotify', 'discord', 'substack', 'medium'],
  },
};

export function classifyDomainCategory(url) {
  if (!url) return null;
  const lower = url.toLowerCase();

  for (const [key, cat] of Object.entries(CATEGORIES)) {
    for (const kw of cat.keywords) {
      if (lower.includes(kw)) {
        return {
          id: key,
          name: cat.name,
          color: cat.color,
          glow: cat.glow,
          border: cat.border,
        };
      }
    }
  }

  return null;
}
